import React, { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import {
  formatPublishedMark,
  readPublishedResultField,
} from "./publishedResultMarks";

function PrintPublishedResultCardList() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [resultCard, setResultCard] = useState(null);
  const [records, setRecords] = useState([]);
  const [scopeLabel, setScopeLabel] = useState("");

  useEffect(() => {
    document.title = "Published Results List";

    const urlParams = new URLSearchParams(window.location.search);
    const resultCardId = parseInt(urlParams.get("ID"), 10) || 0;
    const classId =
      parseInt(urlParams.get("Class_Id"), 10) ||
      parseInt(urlParams.get("ClassId"), 10) ||
      0;
    const sectionId =
      parseInt(urlParams.get("Section_Id"), 10) ||
      parseInt(urlParams.get("SectionId"), 10) ||
      0;

    if (!resultCardId) {
      setError("Select a result card.");
      setLoading(false);
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetPublishedResultCard",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: localStorage.getItem("AccessKey"),
        UserID: localStorage.getItem("ID"),
        MemberType: localStorage.getItem("MemberType"),
        ID: resultCardId,
        Class_Id: classId,
        Section_Id: sectionId,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          const list = response.data.ListofRecords || [];
          setResultCard(response.data.ResultCard || null);
          setRecords(list);

          const first = list[0];
          const parts = [];
          if (first?.Class_Name) {
            parts.push(first.Class_Name);
          }
          if (first?.Section_Name) {
            parts.push(`Section ${first.Section_Name}`);
          }
          setScopeLabel(parts.join(" - "));
          setError("");
        } else {
          setResultCard(null);
          setRecords([]);
          setError(response.data.status_message || "No published results found.");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError("Network error while loading published results.");
      });
  }, []);

  const formatNumber = formatPublishedMark;

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-warning m-4">{error}</div>;
  }

  const title = resultCard?.Print_Title || resultCard?.Title || "Published Results";
  const subtitle = [
    resultCard?.ResultCard_Code,
    resultCard?.Result_Type,
    `Version ${resultCard?.Publish_Version || 1}`,
    scopeLabel,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Page orientation="landscape" size="a4">
      <PrintHeader title={title} />
      <p style={{ fontSize: "10pt", margin: "0 0 12px 0" }}>{subtitle}</p>

      <table className="table table-bordered table-sm table-print" style={{ fontSize: "10pt" }}>
        <thead>
          <tr>
            <th>Pos.</th>
            <th>Reg. No.</th>
            <th>Student Name</th>
            <th>Class</th>
            <th>Section</th>
            <th>Total</th>
            <th>Obtained</th>
            <th>%</th>
            <th>Grade</th>
          </tr>
        </thead>
        <tbody>
          {records.map((item) => (
            <tr key={item.ID}>
              <td>{item.Section_Position || "-"}</td>
              <td>{item.Registration_No}</td>
              <td>{item.Student_Name}</td>
              <td>{item.Class_Name}</td>
              <td>{item.Section_Name}</td>
              <td>{formatNumber(readPublishedResultField(item, "Total_Marks"))}</td>
              <td>{formatNumber(readPublishedResultField(item, "Obtained_Marks"))}</td>
              <td>{formatNumber(readPublishedResultField(item, "Percent_Marks"))}</td>
              <td>{readPublishedResultField(item, "Grade") || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Page>
  );
}

export default PrintPublishedResultCardList;
